
/**
 * Enum for string format tokens used in deal value display formatting
 */
export enum EnumValueFormats {
  /**
   * Token for time segment number in display text
   * Example: "Year {time-seg}" becomes "Year 1", "Year 2", etc.
   */
  TimeSegment = '{time-seg}',

  /**
   * Token for time segment duration in months in display text
   * Example: "{time-seg-dur} months" becomes "12 months", "6 months", etc.
   */
  TimeSegmentDuration = '{time-seg-dur}',

  /**
   * Token for dynamic category code substitution in model codes to create a replacement model code
   * Example: "[categoryCode]-delta-tgt-raw-1" becomes "acv-delta-tgt-raw-1", "tcv-delta-tgt-raw-1", etc.
   * as categoryCode is switched from "acv" to "tcv"
   */
  CategoryCodePlaceholder = '[categoryCode]'
}
